import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'msd-diary-picture-preview-modal',
  templateUrl: './diary-picture-preview-modal.component.html',
  styleUrls: ['./diary-picture-preview-modal.component.scss'],
})
export class DiaryPicturePreviewModalComponent {
  @Input() show: boolean;
  @Input() pictures: string[];
  @Input() selectedIndex = -1;
  @Output() close = new EventEmitter<void>();
}
